// extracted by mini-css-extract-plugin
export default {"onMyDesignHeading":"pzeSop5Zp3ZuF0Es0XUg"};